/* eslint-disable */
// @ts-nocheck
import type { IServiceExtension, IServiceInstanceOptions } from '../types';

export default class TimestampExtension implements IServiceExtension<number> {
  public constructor(private readonly options: IServiceInstanceOptions) {}
  public name: string = 'xTimestamp';
  public getData = () => Date.now();
}
